module.exports = __webpack_public_path__ + "static/N2N1s-1483cca915b58f4362eafc502b712ecc.jpg";